/* eslint-disable @next/next/no-img-element */
import React, { useState } from "react";
import { Button } from "../../../../shadcn/components/ui/button";
import BuildingWithRupee from "../../../../icons/BuildingWithRupee";
import { useSelector } from "react-redux";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from "../../../../shadcn/components/ui/dialog";
import ContactAuthorizedOfficerCard from "../../../../shadcn/components/custom/ContactAuthorizedOfficerCard";
import { Card } from "../../../../shadcn/components/ui/card";
import { getWatermarkedImgixUrl } from "services";

interface PDKnowMoreAboutPropertyCardV2Props {
  propertyData: any;
  setAuthModelOpen: any;
  setAcknowledgementOpen: any;
  setAcknowledgementDetails: any;
}

export const PDKnowMoreAboutPropertyCardV2: React.FC<
  PDKnowMoreAboutPropertyCardV2Props
> = ({
  propertyData,
  setAuthModelOpen,
  setAcknowledgementOpen,
  setAcknowledgementDetails,
}) => {
  const userToken = useSelector((state: any) => state.auth.accessToken);
  const [open, setOpen] = useState(false);

  const clickHandler = async (event: React.MouseEvent) => {
    event.stopPropagation();
    if (userToken) {
      setOpen(true);
    } else {
      setAuthModelOpen(true);
    }
  };
  return (
    <Card className="py-3 bg-white shadow-card-shadow p-4 border-none rounded-[10px]">
      <div className="lg:flex xl:gap-12 overflow-clip">
        <div className="space-y-6 lg:space-y-3">
          <div className="font-space text-xl xl:text-left text-center uppercase">
            Interested in this Property? Need Expert Consultation?
          </div>
          <div className="flex justify-center xl:justify-start items-center">
            <Button className="px-8" onClick={clickHandler}>
              Know More
            </Button>
          </div>
        </div>
        <div className="w-[420px] h-[164px] flex justify-center items-center mx-auto mt-9 lg:mt-0">
          <img
            className="w-full h-full object-contain"
            src={getWatermarkedImgixUrl(
              `${process.env.NEXT_PUBLIC_IMAGIX_URL_STATIC}/b7470893-0f7b-4dc0-b932-6576ad5ed4d7`,
            )}
            alt="Building With Rupee"
          />
        </div>
      </div>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="rounded-lg max-w-[400px]">
          <DialogTitle className="hidden"> </DialogTitle>
          <DialogDescription className="hidden"></DialogDescription>
          <ContactAuthorizedOfficerCard
            propertyData={propertyData}
            setAcknowledgementOpen={setAcknowledgementOpen}
            setAcknowledgementDetails={setAcknowledgementDetails}
            setOpen={setOpen}
            cardType="contactOfficer"
            formTitle="Enter detail"
          />
        </DialogContent>
      </Dialog>
    </Card>
  );
};
